import React from "react";
import styled, {injectGlobal} from "styled-components";
import { breakpoints } from './constants';

const Article = styled.article`
  background-image: ${props => props.bgMobile ? 'url(' + props.bgMobile + ')' : props.bg ? 'url(' + props.bg + ')' : 'transparent'};
  background-color: ${props => props.bgColor ? props.bgColor : 'transparent'};
  background-size: cover !important;
  background-position: center;
  background-repeat: no-repeat;
  background-attachment:fixed;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-flow: column;
  min-height: 950px;
  &:before {
    content: '';
    display: ${props => props.absoluteBg ? 'block' : 'none'};
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    background: white;
  }
  @media (min-width: ${breakpoints.desktop}) {
    background-image: ${props => props.bg ? 'url(' + props.bg + ')' : 'transparent'};
    overflow: inherit;
    min-height: 98vh;
  }
`;

export default Article;



// WEBPACK FOOTER //
// ./src/styled-components/Article.js